export function hasKeyValue(obj: any, key: string, value: any): boolean {
    return obj.hasOwnProperty(key) && obj[key] === value;
}

export function parseUrlSearch(string: string) {
    let result: any = {};
    if (~string.indexOf("?")) {
        let queryString = string.split("?")[1];
        let search = queryString.split("&");
        search.forEach((str) => {
            let kv = str.split("=");
            let key = kv[0];
            let val = kv[1];
            if (key && val) {
                result[key] = val;
            }
        });
    }
    return result;
}
